<template>
  <li v-on:click="selected" class="e4s-sub-nav-link" :class="getClasses">
    <slot> <span v-text="linkTitle" class="e4s-header--400"></span>{{ debug }} </slot>
  </li>
</template>

<script lang="ts">
import { computed, defineComponent, onUpdated, type SetupContext } from 'vue'
import { useConfigController } from '@/config/useConfigStore'

export default defineComponent({
  name: 'sub-nav-link',
  components: {},
  props: {
    linkTitle: {
      type: String,
      default: ''
    },
    linkId: {
      type: String,
      default: ''
    },
    isActive: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    isDisabled: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    isSecondary: {
      type: Boolean,
      default: () => {
        return false
      }
    }
  },
  setup(
    props: {
      linkTitle: string
      isActive: boolean
      isDisabled: boolean
      isSecondary: boolean
    },
    context: SetupContext
  ) {
    const configController = useConfigController()

    onUpdated(() => {
      console.log('section-link-simple ' + '...updated! ' + new Date().toISOString())
    })

    function selected() {
      if (!props.isDisabled) {
        context.emit('selected')
      }
    }

    const getClasses = computed(() => {
      const cssClasses = []

      // const cssClasses = [];
      if (props.isActive) {
        // cssClasses.push('e4s-tab-link--' + cssEnv + 'selected')
        cssClasses.push('e4s-sub-nav--selected')
      }
      if (props.isDisabled) {
        cssClasses.push('e4s-sub-nav--disabled')
      }
      return cssClasses
    })

    const debug = computed(() => {
      return configController.getCssEnvSuffix.value
    })

    return { debug, selected, getClasses, configController }
  }
})
</script>
